"use client";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import HomeMaxIcon from "@mui/icons-material/HomeMax";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ShareIcon from "@mui/icons-material/Share";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Loader } from "../genericComponents/MainLoader/Loader";

export const FooterNavigation = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const pathName = usePathname();

  useEffect(() => {
    const value = localStorage.getItem("isAlreadyLogin");
    setIsLogin(value === "true");
  }, []);

  const handleLoader = () => {
    setLoading(true);
  };
  const blankFunction = () => {};

  return (
    <>
      {isSmallScreen ? (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            backgroundColor: "white",
            color: "black",
            padding: "4px 10px",
            textAlign: "center",
            zIndex: "1000",
          }}
        >
          {loading && <Loader />}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                color: pathName == "/" ? "#15741a" : "",
                width: "20%",
                display: "block",
              }}
            >
              <Link
                prefetch={false}
                href={"/"}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={pathName !== "/" ? handleLoader : blankFunction}
              >
                <HomeMaxIcon />
                <br />
                <Typography variant="caption">Home</Typography>
              </Link>
            </Box>
            <Box
              sx={{
                width: "20%",
                color: pathName == "/store" ? "#15741a" : "",
              }}
            >
              <Link
                prefetch={false}
                href={"/store"}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={pathName !== "/store" ? handleLoader : blankFunction}
              >
                <ShoppingBagIcon />
                <br />
                <Typography variant="caption">Store</Typography>
              </Link>
            </Box>
            {isLogin ? (
              <Box
                sx={{
                  width: "20%",
                  color: pathName == "/appointments" ? "#15741a" : "",
                }}
              >
                <Link
                  prefetch={false}
                  href={"/appointments"}
                  style={{ textDecoration: "none", color: "inherit" }}
                  onClick={
                    pathName !== "/appointments" ? handleLoader : blankFunction
                  }
                >
                  <CalendarMonthIcon />
                  <br />
                  <Typography variant="caption">Bookings</Typography>
                </Link>
              </Box>
            ) : (
              <Box
                sx={{
                  width: "20%",
                  color: pathName == "/contact" ? "#15741a" : "",
                }}
              >
                <Link
                  prefetch={false}
                  href={"/contact"}
                  style={{ textDecoration: "none", color: "inherit" }}
                  onClick={
                    pathName !== "/contact" ? handleLoader : blankFunction
                  }
                >
                  <PermContactCalendarIcon />
                  <br />
                  <Typography variant="caption">Contact</Typography>
                </Link>
              </Box>
            )}
            <Box
              sx={{
                width: "20%",
                color: pathName == "/refer&earn" ? "#15741a" : "",
              }}
            >
              <Link
                prefetch={false}
                href={"./refer&earn"}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={
                  pathName !== "/refer&earn" ? handleLoader : blankFunction
                }
              >
                <ShareIcon />
                <br />
                <Typography variant="caption">Rfer & Earn</Typography>
              </Link>
            </Box>
          </Box>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};
